import { SVGProps, Ref, forwardRef, useId } from 'react';

export const EmojiNeutral3dSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => {
    const _uniqueId = useId();
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g filter={`url(#${_uniqueId}filter0_i_8745_51)`} suppressHydrationWarning>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 1C2.375 1 1 2.375 1 12s1.375 11 11 11 11-1.375 11-11S21.625 1 12 1M9 16.1v1.8h6v-1.8zm8.5-5.7h-4V8.6h4zm-11 0h4V8.6h-4z"
                    fill={`url(#${_uniqueId}paint0_radial_8745_51)`}
                    suppressHydrationWarning
                />
                <path
                    d="M10.5 10.4h-4V8.6h4z"
                    fill={`url(#${_uniqueId}paint1_radial_8745_51)`}
                    suppressHydrationWarning
                />
                <path
                    d="M13.5 10.4h4V8.6h-4z"
                    fill={`url(#${_uniqueId}paint2_radial_8745_51)`}
                    suppressHydrationWarning
                />
                <path
                    d="M9 17.9v-1.8h6v1.8z"
                    fill={`url(#${_uniqueId}paint3_radial_8745_51)`}
                    suppressHydrationWarning
                />
            </g>
            <path d="M10.5 10.4h-4V8.6h4z" fill="#79610C" />
            <path d="M13.5 10.4h4V8.6h-4z" fill="#79610C" />
            <path d="M9 17.9v-1.8h6v1.8z" fill="#79610C" />
            <defs>
                <filter
                    id={`${_uniqueId}filter0_i_8745_51`}
                    x={1}
                    y={-2.75}
                    width={25.75}
                    height={25.75}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                    suppressHydrationWarning
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx={3.75} dy={-3.75} />
                    <feGaussianBlur stdDeviation={3.75} />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_8745_51" />
                </filter>
                <radialGradient
                    id={`${_uniqueId}paint0_radial_8745_51`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16.7094 5.125) rotate(127.875) scale(19.5968)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint1_radial_8745_51`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16.7094 5.125) rotate(127.875) scale(19.5968)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint2_radial_8745_51`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16.7094 5.125) rotate(127.875) scale(19.5968)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint3_radial_8745_51`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16.7094 5.125) rotate(127.875) scale(19.5968)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
            </defs>
        </svg>
    );
});
EmojiNeutral3dSize24Glyph.displayName = 'EmojiNeutral3dSize24Glyph';
